export default "__VITE_ASSET__B$j1RX7t__"